import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-ccf',
  templateUrl: './consulta-ccf.component.html',
  styleUrls: ['./consulta-ccf.component.scss']
})
export class ConsultaCcfComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
    if(!this.consulta.registros || this.consulta.registros.length == 0) {
      this.codigoControle = 'SEMREGISTRO_OK';
    }
    
    if(this.codigoControle == "SEMREGISTRO_OK") {
      this.status = 'success';
    }

  }

}
